import cx from 'classnames';
import styles from './form-group.module.scss';
import type {FC, ReactNode} from 'react';

interface FormGroupProps {
  readonly children: ReactNode;
  readonly className?: string;
  readonly invalid?: boolean;
}

const FormGroup: FC<FormGroupProps> = ({children, className, invalid}) => (
  <div className={cx(styles.form_group_container, className)}>
    <label
      className={cx(
        [styles.basic],
        {[styles.primary]: !invalid},
        {[styles.accent]: !invalid},
        {[styles.invalid]: invalid},
      )}
    >
      {children}
    </label>
  </div>
);

export default FormGroup;
